import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CommonService } from "../../../../services/common.service";

@Component({
  selector: "plan-calendar",
  templateUrl: "./calendar.component.html",
})
export class PlanCalendarComponent implements OnInit {
  /* THIS MAKES EVERY CALENDAR UPDATED */
  @Input()
  set targetDay(date: any) {
    if (
      this.moment(date, "YYYY-MM-DD", true).isValid() === true ||
      this.moment(date, "YYYYMMDD", true).isValid() === true
    ) {
      this._targetDay = date;

      let thisDate = this.moment(this._targetDay);
      this.day = thisDate.endOf("month").format("DD");
      this.month = thisDate.format("MM");
      this.year = thisDate.format("YYYY");
      this.apply();
    }
  }

  @Input() selectedDay: string;
  @Input() dismiss: string; /* FOR CLOSING MODAL. EX. */
  @Input() showSelected: string;
  @Input()
  set bestPriceList(data: any) {
    /* SET NEW PRICE LIST */
    this._bestPriceList = data;

    /* SET LOWEST PRICE */
    this.setLowestPrice();
  }

  @Output() onMonthChanged = new EventEmitter<any>();
  @Output() onDayChanged = new EventEmitter<any>();

  public $: any;
  public moment: any;
  public _: any;

  public _targetDay: string;
  public _bestPriceList: any;
  public day: any;
  public month: any;
  public prevMonth: any;
  public nextMonth: any;
  public thisMonth: any;
  public year: any;
  public thisYear: any;
  public startDay: number;
  public endDay: number;
  public viewingDate: string;

  public hasPrev: boolean;

  public lowestPrice: any = 0;

  constructor(public commonService: CommonService) {
    this.$ = this.commonService.getJQuery();
    this.moment = this.commonService.getMoment();
    this._ = this.commonService.getLodash();
    this.thisMonth = this.moment().format("MM");
    this.thisYear = this.moment().format("YYYY");
  }

  ngOnInit() {
    if (this._targetDay) {
      let targetDayMoment = this.moment(this._targetDay);
      this.day = targetDayMoment.format("DD");
      this.month = targetDayMoment.format("MM");
      this.year = targetDayMoment.format("YYYY");
    } else {
      this.day = "01";
      this.month = this.thisMonth;
      this.year = this.thisYear;
    }

    this.hasPrev = false;

    this.showSelected = this.showSelected ? this.showSelected : "yes";

    this.apply();
  }

  setLowestPrice() {
    /* SET LOWEST PRICE */

    let currentYearMonth = `${this.year}-${this.month}`;
    let lowestPrice = 999999;

    for (let date in this._bestPriceList) {
      if (
        date.substr(0, 7) == currentYearMonth &&
        Number(this._bestPriceList[date].min_price) < Number(lowestPrice)
      ) {
        lowestPrice = this._bestPriceList[date].min_price;
      }
    }

    this.lowestPrice = lowestPrice;
  }

  apply() {
    this.viewingDate = `${this.year}-${this.month}-${this.day}`;
    this.prevMonth = parseInt(this.month) - 1;
    this.prevMonth = this.prevMonth >= 1 ? this.prevMonth : 12;
    this.nextMonth = parseInt(this.month) + 1;
    this.nextMonth = this.nextMonth <= 12 ? this.nextMonth : 1;
    this.startDay = this.moment(`${this.year}-${this.month}-01`).day();
    this.endDay = this.moment(this.viewingDate).daysInMonth();

    /* CHECK IF HAS PREV */
    if (
      parseInt(this.thisYear + "" + this.thisMonth) <
      parseInt(this.year + "" + this.month)
    ) {
      this.hasPrev = true;
    } else {
      this.hasPrev = false;
    }

    /* SET LOWEST PRICE */
    this.setLowestPrice();
  }

  getPrevMonth() {
    if (this.hasPrev) {
      let thisDate = this.moment(this.viewingDate).subtract(1, "months");

      this.day = thisDate.endOf("month").format("DD");
      this.month = thisDate.format("MM");
      this.year = thisDate.format("YYYY");

      this.apply();
      this.changeMonth();
    }
  }

  getNextMonth() {
    let thisDate = this.moment(this.viewingDate).add(1, "months");

    this.day = "01";
    this.month = thisDate.format("MM");
    this.year = thisDate.format("YYYY");

    this.apply();
    this.changeMonth();
  }

  /* OUTPUT EMITS */
  changeDay(day: any = "01") {
    day = this.commonService.stringPad(day);
    /* EMIT TO PARENT */
    this.onDayChanged.emit({
      year: this.year,
      month: this.month,
      day: day,
      date: `${this.year}-${this.month}-${day}`,
      monthJustChanged: this.showSelected == "no" ? true : false,
    });

    /* CLOSE DRAWER IF IT EXISTS */
    if (this.$(".drawer3").length !== 0) {
      this.$(".drawer3").drawer("close");
    }
  }

  changeMonth() {
    /* EMIT TO PARENT */
    this.onMonthChanged.emit({
      year: this.year,
      month: this.month,
      day: this.day,
      date: this.viewingDate,
      monthJustChanged: true,
    });
  }
  /* END */

  showLastSeat(number: any = "") {
    if (isNaN(number)) {
      return number;
    }
    if (number < 10) {
      return `${number}席`;
    } else if (number >= 10 && number <= 19) {
      return `〇`;
    } else {
      return `◎`;
    }
  }
}
